export const addColorModal = {
  extend: 'ModalWindow',
  tag: 'form',
  ModalHeader: {
    title: 'Add color',
    p: 'Select the color of your theme, give a name and type the specific code.'
  },
  Flex: {
    gap: 'C1',
    padding: 'Z2 -',
    ColorPreview: {
      minWidth: 'auto',
      minHeight: 'auto',
      aspectRatio: '1 / 1',
      margin: '-W',
      flex: 3.5
    },
    Fields: {
      flex: 5,
      flexFlow: 'y',
      gap: 'B1',
      ColorPickerWithTitle: {
        Title: {
          text: '{{ editor.addColor.code | polyglot }}'
        },
        ColorPicker: {
          Input: {
            placeholder: '#123',
            onInput: async (ev, el, s, ctx) => {
              const isEditing = window.location.pathname.includes('edit-color')
              if ((s.changedByInput && s.key) || isEditing) return
              const value = ev.target.value
              // nameTheColor's ~42 KB color table stays out of the eager
              // bundle — loaded on demand (bundle-split T2)
              const { nameTheColor } = await import('../functions/ntc.js')
              const key = ctx.utils.toCamelCase(nameTheColor.name(value)[1])
              s.update({
                value,
                key
              })
            }
          },
          Value: {
            ColorTemplate: {},
            Text: {
              text: '{{ value }}'
            }
          }
        }
      },
      // The shared field kit (components/AppField.js): caption label above
      // the control, the brand `field` fill with the hairline edge.
      AppField: {
        label: (el) => el.call('polyglot', 'editor.addColor.name'),
        AppInput: {
          placeholder: 'PinkPanther',
          value: '{{ key }}',
          onInput: (e, el, s) => {
            s.update({
              changedByInput: true,
              key: el.node.value
            })
          }
        }
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      icon: 'plus',
      text: '{{ common.action.add | polyglot }}'
    }
  },
  props: {
    onInit: async (el, s, ctx) => {
      if (!el.getDesignSystem()) return
      const lastPath = el.call('getLastLocationPath')
      const value = window.location.hash
      let key
      if (value) {
        // lazy — see onInput above (bundle-split T2)
        const { nameTheColor } = await import('../functions/ntc.js')
        key = el.call('toCamelCase', nameTheColor.name(value)[1])
      } else {
        key = lastPath !== '/add-color' && lastPath.slice(1)
      }
      s.quietUpdate({
        key,
        value
      })
    },
    onSubmit: (e, el, s, ctx) => {
      e.preventDefault()
      const { key, value } = s
      if (!key || !value) return
      ctx.utils.closeModal(el, s, ctx)
      const t = setTimeout(() => {
        el.updateDesignSystem({
          color: {
            [key]: value
          }
        })
        clearTimeout(t)
      }, 75)
    }
  }
}
